import { getQueryParam } from '../routing/getQueryParam';
export const getClickTrackingProperties = () => {
  const fbclid = getQueryParam('fbclid');
  const msclkid = getQueryParam('msclkid');
  const liFatId = getQueryParam('li_fat_id');
  const ttclid = getQueryParam('ttclid');
  const rdtCid = getQueryParam('rdt_cid');
  return Object.assign({}, fbclid && {
    fbclid
  }, msclkid && {
    msclkid
  }, liFatId && {
    liFatId
  }, ttclid && {
    ttclid
  }, rdtCid && {
    rdtCid
  });
};